export default () => {
  const customPlayback = (element) => {
    const video = element.previousElementSibling;

    if (!video) {
      return;
    }

    const playPauseButton = element;
    const playPauseButtonText = element.querySelector('.visually-hidden');

    if (video.paused) {
      video.play();
      playPauseButtonText.textContent = 'Pause';
      playPauseButton.setAttribute('aria-label', 'Pause video');
    } else {
      video.pause();
      playPauseButtonText.textContent = 'Play';
      playPauseButton.setAttribute('aria-label', 'Play video');
    }
  };

  document.addEventListener('click', (e) => {
    const el = e.target;

    if (el.classList.contains('action-video')) {
      customPlayback(el);
    }
  });
};
